import React from "react";
import "./index.css";
import { Flex } from "@chakra-ui/core";

const Loader = () => {
  return (
    <Flex
      width='100%'
      height='100%'
      zIndex='20'
      backgroundColor='rgba(255,255,255,1)'
      align='center'
      justify='center'
      direction='column'
      flex='1'
    >
      <div className='loader'></div>
    </Flex>
  );
};

export default Loader;
